<div class="appo-arrival-confirm-dialog">
  <si-generic-dialog [(displayDialog)]="displayDialog"
                     dialogTitle="SI_CONFIRM_ARRIVAL"
                     dialogTitleStyleClass="generic-dialog_title mb-3"
                     button1Text="SI_CONFIRM"
                     button1Class="si-button_main"
                     [button1Close]="false"
                     [button1Disabled]="appoArrivalConfirmDialogForm?.invalid"
                     button2Text="SI_CANCEL"
                     button2Class="si-button_secondary"
                     [isScrollable]="true"
                     (updateButton1Change)="onClickConfirmArrival()"
                     (displayDialogChange)="onClickCloseDialog()">
    <div>
      <div class="appo-arrival-confirm-dialog_text" [innerHTML]="('SI_CONFIRM_ARRIVAL_DESCRIPTION' | translate)"></div>
      <div class="mt-4">
        <div class="d-flex align-items-center">
          <i class="icosun-map mr-1"></i>
          <span class="appo-arrival-confirm-dialog_center">{{centerName}}</span>
        </div>
        <div class="ml-4 appo-arrival-confirm-dialog_address">{{centerAddress}}</div>
      </div>
      <div *ngIf="isMapsInitialized" class="mt-2">
        <si-maps #maps
                 [showCenter]="true"
                 [options]="mapOptions"
                 [mapHeight]="mapHeight"
                 [markerOptions]="markerOptions"
                 [defaultCoords]="[centerLatitude, centerLongitude]"
                 [defaultAddress]="centerAddress"
        ></si-maps>
      </div>
      <div class="mt-4" [innerHTML]="'SI_CONFIRM_ARRIVAL_INFO' | translate"></div>
      <form #appoArrivalConfirmDialogForm="ngForm"
            id="appoArrivalConfirmDialogForm"
            name="appoArrivalConfirmDialogForm">
        <ng-container *ngIf="actions?.includes('IS_SEOGA_REQUIRED') || requiresSEOGA">
          <div class="mt-3" [innerHTML]="'SI_ARRIVAL_CONFIRM_INSURANCE_DATA' | translate"></div>
          <si-label styleClass="mt-3"
                    text="{{'SI_INSURANCE_IDENTIFICATION' | translate}}"
          ></si-label>
          <div class="si-radio-button-container_horizontal">
            <si-radio-button id="appoArrivalConfirmDialogRadioCardNumber"
                             name="appoArrivalConfirmDialogRadioCardNumber"
                             text="SI_CARD_NUMBER"
                             [(model)]="model.insuranceIdentificationType"
                             (modelChange)="onChangeInsuranceIdentificationType()"
                             [value]="appointmentInsuranceIdentificationType.CARD_NUMBER"
                             [checked]="true"
            ></si-radio-button>
            <si-radio-button id="appoArrivalConfirmDialogRadioLocator"
                             name="appoArrivalConfirmDialogRadioLocator"
                             text="SI_LOCATOR"
                             [(model)]="model.insuranceIdentificationType"
                             (modelChange)="onChangeInsuranceIdentificationType()"
                             [value]="appointmentInsuranceIdentificationType.LOCATOR"
            ></si-radio-button>
          </div>
          <div class="mt-3">
            <si-input id="appoArrivalConfirmDialogIdentification"
                      name="appoArrivalConfirmDialogIdentification"
                      placeholder="SI_WRITE_HERE"
                      [(model)]="model.insuranceIdentificationCode"
                      (modelChange)="onChangeInsuranceIdentificationCode()"
                      [hideLabel]="true"
                      rule="generic.fieldNotNullLength50"
            ></si-input>
          </div>
          <ng-container *ngIf="actions?.includes('IS_SEOGA_AUTHORIZATION_REQUIRED') || requiresSEOGAAuthorization">
            <div class="mt-3">
              <si-input id="appoArrivalConfirmDialogAuthorization"
                        name="appoArrivalConfirmDialogAuthorization"
                        text="SI_AUTHORIZATION_CODE"
                        placeholder="SI_WRITE_HERE"
                        [(model)]="model.authorizationCode"
                        rule="generic.fieldNotNullLength50"
              ></si-input>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="allowVouchers">
          <div class="mt-3" [innerHTML]="'SI_VOUCHER_MANAGEMENT_INFO' | translate"></div>
          <si-label styleClass="mt-3"
                    text="{{'SI_PAYMENT_TYPE' | translate}}"
          ></si-label>
          <div class="si-radio-button-container_horizontal">
            <si-radio-button id="appoArrivalConfirmDialogRadioVoucher"
                             name="appoArrivalConfirmDialogRadioVoucher"
                             text="SI_VOUCHER"
                             [(model)]="model.voucherIdentificationType"
                             (modelChange)="onChangeVoucherIdentificationType()"
                             [value]="appointmentVoucherIdentificationType.VOUCHER"
                             [checked]="true"
            ></si-radio-button>
            <si-radio-button id="appoArrivalConfirmDialogRadioCardOrCash"
                             name="appoArrivalConfirmDialogRadioCardOrCash"
                             text="SI_CARD_OR_CASH"
                             [(model)]="model.voucherIdentificationType"
                             (modelChange)="onChangeVoucherIdentificationType()"
                             [value]="appointmentVoucherIdentificationType.CARD_OR_CASH"
            ></si-radio-button>
          </div>
          <div *ngIf="model.voucherIdentificationType === appointmentVoucherIdentificationType.VOUCHER"
                class="mt-3">
            <si-selector id="appoArrivalConfirmDialogVoucher"
                         name="appoArrivalConfirmDialogVoucher"
                         text="SI_VOUCHER"
                         placeholder="SI_SELECT_PLACEHOLDER"
                         [(model)]="model.voucherId"
                         (modelChange)="onChangeVoucherId()"
                         [values]="voucherList"
                         valueAttr="id"
                         [selectSingle]="true"
                         [openTop]="true"
                         rule="generic.fieldNotNull"
            ></si-selector>
          </div>
        </ng-container>
      </form>
    </div>
  </si-generic-dialog>
</div>

<ng-container *ngIf="displayConfirmArrivalErrorDialog">
  <si-generic-dialog [(displayDialog)]="displayConfirmArrivalErrorDialog"
                     (displayDialogChange)="onCloseConfirmArrivalErrorDialog()"
                     dialogTitle="SI_ARRIVAL_NOT_CONFIRMED_TITLE"
                     dialogImg="assets/images/confirm-arrival-error.svg"
                     dialogText="SI_ARRIVAL_CONFIRM_ERROR_TEXT"
                     button1Text="SI_CLOSE"
                     button1Class="si-button_secondary"
  ></si-generic-dialog>
</ng-container>
